const urlcode_map = {
  '%2F': 'uc9ueijc', // /的编码
  '%5C': 'ifelfefd'// \的编码
}

function url_coded (str) {
  var result = ''
  var chars = getKeys(urlcode_map)
  for (var i = 0; i < str.length; i++) {
    let s = encodeURIComponent(str[i])
    if (chars.indexOf(s) > -1) {
      s = urlcode_map[s]
    }
    result += s
  }
  return result
}

function url_decoded (str) {
  var chars = getValues(urlcode_map)
  var result = str
  for (let i = 0; i < chars.length; i++) {
    let c = chars[i]
    let reg = new RegExp(c, 'g')
    let k = findKey(urlcode_map, c)
    result = result.replace(reg, k)
  }
  return decodeURIComponent(result)
}

function getKeys (map) {
  var result = []
  for (var k in map) {
    result.push(k)
  }
  return result
}
function getValues (map) {
  var result = []
  for (var k in map) {
    result.push(map[k])
  }
  return result
}
function findKey (obj, value, compare = (a, b) => a === b) {
  return Object.keys(obj).find(k => compare(obj[k], value))
}

export default {
  url_coded: url_coded,
  url_decoded: url_decoded
}



// WEBPACK FOOTER //
// ./src/utils/urlencode.js